import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import { RouterOutlet } from '@angular/router';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AccountSetupWizardService } from './modules/employees/services/account-setup-wizard.service';
import {AuthService} from "./services/auth.service";
import {decodeJwt} from "./utils";
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, TourMatMenuModule, MatCardModule, MatIconModule, MatButtonModule, TourMatMenuModule, MatCardModule, MatIconModule, MatButtonModule, NgIf]
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    public accountSetupWizardService: AccountSetupWizardService,
  ) {
    this.translate.addLangs(['sk', 'de']);
    this.translate.use('sk');
  }

  ngOnInit(): void {
    const token = this.authService.jwt;
    if (token) {
      const decoded = decodeJwt(token);
      if (decoded && decoded.isAccountAdmin === undefined) {
        this.authService.logOut();
      }
    }
  }

}
